export const birthCrtfctSeriesLetters = [
    {
        key: "0",
        value: "الف"
    },
    {
        key: "1",
        value: "ب"
    },
    {
        key: "2",
        value: "ل"
    },
    {
        key: "3",
        value: "د"
    },
    {
        key: "4",
        value: "ر"
    },
    {
        key: "5",
        value: "1"
    },
    {
        key: "6",
        value: "2"
    },
    {
        key: "7",
        value: "3"
    },
    {
        key: "8",
        value: "4"
    },
    {
        key: "9",
        value: "9"
    },
    {
        key: "10",
        value: "10"
    },
    {
        key: "11",
        value: "11"
    },
    {
        key: "12",
        value: "ش"
    }
]